import * as React from 'react';
import { Link } from 'react-router-dom';

const pagesStyles = require('./pages.css');

export interface NotFoundProps {
  message?: string;
  returnLabel?: string;
  returnTo?: string;
  title?: string;
}

export const NotFound = ({
  message = 'The page you requested does not exist.',
  returnLabel = 'Go to accounts',
  returnTo = '/accounts',
  title = 'Page not found',
}: NotFoundProps) => (
  <main
    aria-labelledby="not-found-heading"
    className={`${pagesStyles.container} ${pagesStyles.notFoundPage}`}
  >
    <img
      alt=""
      className={pagesStyles.notFoundImage}
      height={730}
      src="/images/page-404.jpg"
      width={800}
    />
    <h1 id="not-found-heading">404: {title}</h1>
    <p>{message}</p>
    <Link className="btn btn-primary" to={returnTo}>
      {returnLabel}
    </Link>
  </main>
);
